import * as React from 'react';

import './CardSection.scss';

interface ICardSectionProps {
    title: string;
}

const CardSection: React.StatelessComponent<ICardSectionProps> = (props) => {
    return (
        <div className="lh-card-section" title="Project Administration">
            <div className="card-header lh-mb-small">{props.title}</div>
            {props.children}
        </div>
    );
};

export default CardSection;



// WEBPACK FOOTER //
// ./src/components/common/CardSection.tsx